// Mobile Navigation JavaScript
class MobileNav {
  constructor() {
    this.trigger = document.querySelector('[data-mobile-nav-trigger]');
    this.drawer = document.querySelector('[data-mobile-nav-drawer]');
    this.backdrop = document.querySelector('[data-mobile-nav-backdrop]');
    this.closeBtn = document.querySelector('[data-mobile-nav-close]');
    this.body = document.body;
    this.isOpen = false;

    this.init();
  }

  init() {
    if (!this.trigger || !this.drawer) return;

    // Bind events
    this.trigger.addEventListener('click', () => this.toggle());
    this.closeBtn?.addEventListener('click', () => this.close());
    this.backdrop?.addEventListener('click', () => this.close());

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });

    // Close on outside click
    this.drawer?.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    // Handle window resize
    window.addEventListener('resize', () => {
      if (window.innerWidth > 768 && this.isOpen) {
        this.close();
      }
    });
  }

  toggle() {
    this.isOpen ? this.close() : this.open();
  }

  open() {
    this.isOpen = true;
    this.body.classList.add('mobile-nav-open');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.trigger.setAttribute('aria-label', 'Close mobile menu');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.backdrop.setAttribute('aria-hidden', 'false');

    // Focus management
    this.drawer.focus();
  }

  close() {
    this.isOpen = false;
    this.body.classList.remove('mobile-nav-open');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.trigger.setAttribute('aria-label', 'Open mobile menu');
    this.drawer.setAttribute('aria-hidden', 'true');
    this.backdrop.setAttribute('aria-hidden', 'true');

    // Return focus to trigger
    this.trigger.focus();
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new MobileNav());
} else {
  new MobileNav();
}

// NOTE (Issue #64, 2026-07-14): the Judge.me floating-reviews-tab hider was removed
// with the Judge.me app — its markup can no longer appear, so the querySelector sweep
// + MutationObserver were dead weight on every page load.
